import React, { useState, useEffect } from "react";
import Footer from "../components/Shared/Footer";
import Swal from "sweetalert2";
import { useLocation } from "react-router-dom";
import axios from 'axios';

const baseUrl = process.env.REACT_APP_BASE_URL; // Base URL from environment


const AppointmentConfirmation = () => {
  const [status, setStatus] = useState("");
  const [meetLink, setMeetLink] = useState("");
  const [reason, setReason] = useState("");
  const [token, setToken] = useState("");
  const [appointmentId, setAppointmentId] = useState("");
  const [isValidUrl, setIsValidUrl] = useState(true);
  const [isProcessing, setIsProcessing] = useState(false);
  const location = useLocation();

  useEffect(() => {
    // Parse query parameters
    const params = new URLSearchParams(location.search);
    const actionParam = params.get("action");
    const tokenParam = params.get("t");
    const appointmentIdParam = params.get("appointment_id");

    // Check if all required parameters are present
    if (!actionParam || !tokenParam || !appointmentIdParam) {
      setIsValidUrl(false);
      return;
    }

    setToken(tokenParam);
    setAppointmentId(appointmentIdParam);
    setStatus(actionParam);
  }, [location]);

  if (!isValidUrl) {
    return (
        <div>
      <div className="container my-5">
        <div className="row justify-content-center">
          <div className="col-md-6">
            <div className="card">
              <div className="card-body text-center">
                <h3 className="card-title text-danger mb-4">Invalid URL</h3>
                <p className="card-text">
                  The link you're trying to access is invalid or incomplete.
                  Please check the URL and try again.
                </p>
              </div>
            </div>
          </div>
        </div>
        </div>
        <Footer />
      </div>
    );
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsProcessing(true);
    try {
      const params = new URLSearchParams({
        token,
        appointment_id: appointmentId,
        action: status,
        meet_link: meetLink || '',
        reason: reason || '',
        schema: 'public' // Adding default schema
      });
      const response = await axios.put(
        `${baseUrl}/user_product_appointments/confirmation?${params.toString()}`
      );

      console.log('API Response:', response.data);

      await Swal.fire({
        icon: "success",
        title: "Success!",
        text: response.data.message || "Appointment status updated successfully",
        confirmButtonColor: "var(--theme-color1)",
        confirmButtonText: "OK"
      });
    } catch (error) {
      console.error('Error:', error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: error.response?.data?.detail || "Failed to update appointment status",
        confirmButtonColor: "var(--theme-color1)",
      });
    } finally {
      setIsProcessing(false);
    }
  };

  return (
    <div>
    <div className="container my-5">
      <div className="row justify-content-center">
        <div className="col-md-6">
          <div className="card">
            <div className="card-body">
              <h3 className="card-title text-center mb-4">
                Appointment Confirmation
              </h3>
              <form onSubmit={handleSubmit}>
                <div className="mb-3">
                  <label className="form-label">Status</label>
                  <select
                    className="form-select"
                    value={status}
                    onChange={(e) => setStatus(e.target.value)}
                    required
                  >
                    <option value="">Select Status</option>
                    <option value="confirm">Confirm</option>
                    <option value="reject">Reject</option>
                  </select>
                </div>

                {status === "confirm" && (
                  <div className="mb-3">
                    <label className="form-label">Google Meet Link</label>
                    <input
                      type="url"
                      className="form-control"
                      value={meetLink}
                      onChange={(e) => setMeetLink(e.target.value)}
                      placeholder="Enter Google Meet link"
                      required
                    />
                  </div>
                )}

                {status === "reject" && (
                  <div className="mb-3">
                    <label className="form-label">Reason for Rejection</label>
                    <textarea
                      className="form-control"
                      value={reason}
                      onChange={(e) => setReason(e.target.value)}
                      placeholder="Enter reason for rejection"
                      required
                      rows="3"
                    />
                  </div>
                )}

                <button
                  onClick={handleSubmit}
                  className="btn-assessment font-xsm btns btn-animation-blue mt-xxl-4 mt-2 home-button"
                  disabled={isProcessing}
                >
                  {isProcessing ? (
                    <>
                      <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                      ...
                    </>
                  ) : (
                    "Submit"
                  )}
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
      
    </div>
    <Footer />
    </div>
  );
};

export default AppointmentConfirmation;
